import React from 'react';
import { useDispatch } from "react-redux";
import { setOrderFilter } from "../../store/orderSlice";

const Widget = ({ mainClass, textColorClass, isActive, value, label, sublabel, onClick }) => {
  return (
    <div className="col-md-6 col-xl">
      <div className={`widget-rounded-circle card-box summary-card-box cursor-pointer ${mainClass} ${isActive ? "active" : ""}`} onClick={onClick}>
        <h6 className="text-truncate card-box-title">{label}</h6>
        <div className="row">
          <div className="col-auto">
            <h5 className={`card-box-subtitle`}>{sublabel}</h5>
          </div>
          <div className="col">
            <h5 className={`card-box-value text-right ${textColorClass}`}>{value}</h5>
          </div>
        </div>
      </div>
    </div>
  );
};

const StatusSummary = ({ orderState,isDisabled }) => {
  const dispatch = useDispatch();

  const statusSummary = orderState.orderStatusSummary;
  const customStatus = orderState.filter.customStatus ? orderState.filter.customStatus : null;

  const onClickStatusFilter = (customStatusId) => {
    if (isDisabled) return;

    dispatch(
      setOrderFilter({
        ...orderState.filter,
        customStatus: orderState.filter.customStatus === customStatusId ? null : customStatusId,
        currentPage: 1,
      })
    );
  };

  const widgetsData = [
    {
      value: statusSummary && statusSummary.status_unfulfilled ? statusSummary.status_unfulfilled : 0,
      label: "Orders - Unfulfilled",
      sublabel: "[Action Needed]",
      mainClass: "card-box-danger",
      isActive: customStatus == 1,
      onClick: () => onClickStatusFilter(1),
    },
    {
      value: statusSummary && statusSummary.status_tracking_details_added ? statusSummary.status_tracking_details_added : 0,
      label: "Orders - Tracking Details Added",
      sublabel: "[Action Needed]",
      mainClass: "card-box-warning",
      isActive: customStatus == 2,
      onClick: () => onClickStatusFilter(2),
    },
    {
      value: statusSummary && statusSummary.status_in_transit ? statusSummary.status_in_transit : 0,
      label: "Orders - In Transit",
      sublabel: "[No Action Needed]",
      mainClass: "card-box-info",
      isActive: customStatus == 3,
      onClick: () => onClickStatusFilter(3),
    },

    {
      value: statusSummary && statusSummary.status_delivered ? statusSummary.status_delivered : 0,
      label: "Orders - Delivered",
      sublabel: "[No Action Needed]",
      mainClass: "card-box-success",
      isActive: customStatus == 4,
      onClick: () => onClickStatusFilter(4),
    },
    {
      value: statusSummary && statusSummary.status_stuck_in_transit ? statusSummary.status_stuck_in_transit : 0,
      label: "Orders - Stuck in Transit",
      sublabel: "[Action Needed]",
      mainClass: "card-box-secondary",
      isActive: customStatus == 5,
      onClick: () => onClickStatusFilter(5),
    },
  ];

  return (
    <>
      <div className="row">
        {widgetsData.map((widget, index) => (
          <Widget
            key={"s" + index}
            mainClass={widget.mainClass}
            // textColorClass={widget.textColorClass}
            value={widget.value}
            label={widget.label}
            sublabel={widget.sublabel}
            onClick={widget.onClick}
            isActive={widget.isActive ?? false}
          />
        ))}
      </div>
    </>
  );
};

export default StatusSummary;
